import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorker from 'serviceWorker';
import 'index.css';
import 'assets/fonts/fonts.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import AppRoutes from 'routes/intex';
import store from 'store';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { pdfjs } from 'react-pdf';
import './sentry';
import * as Sentry from '@sentry/react';
import { initAmplitude } from 'utils/amplitude.util';

initAmplitude();

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
  {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  }
);

const theme = createTheme({
  palette: {
    primary: {
      main: '#0584FE',
    },
    secondary: {
      main: '#FFFFFF',
    },
  },
});

root.render(
  <Sentry.ErrorBoundary>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  </Sentry.ErrorBoundary>
);
serviceWorker.unregister();
